const checkoutButtons = document.querySelectorAll('button[name="checkout"]')
const audiogramCheck = document.querySelector('.audiogram-notice input[type="checkbox"]')

// HELPER FUNCTIONS
function ToggleCheckouts () {
    if (audiogramCheck.checked) {
        checkoutButtons.forEach((elem) => {
            elem.disabled = false
            // elem.removeEventListener("click", (e) => showWarning(e))
        })
        return;
    }
    checkoutButtons.forEach((elem) => {
        elem.disabled = true
        // if (is_touch_enabled()) {
        //     elem.addEventListener("click", (e) => showWarning(e))
        // }
    })
}

function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
}

function hideWarning(e) {
    e.querySelector('p').classList.remove("show-warning")
}
function showWarning (e) {
    e.querySelector('p').classList.add("show-warning")
    setTimeout(() => hideWarning(e), 5000);
}

// THREAD START
ToggleCheckouts()

audiogramCheck.addEventListener("change", ToggleCheckouts)
